import { Component, Input, Output, EventEmitter, SimpleChanges, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule, FormGroup } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatOptionModule } from '@angular/material/core';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import MaterialGroupAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/materials/material-group/material-group.entity';
import MaterialBrandAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/materials/material-brand/material-brand.entity';
import { MaterialGroupService } from '../../material/material-group/material-group.service';
import { MaterialService } from '../../material/material/material.service';
import { MaterialBrandService } from '../../material/material-brand/material-brand.service';
import { getCode } from 'app/utils/method';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Subscription } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';
@Component({
  selector: 'app-materials-management-filters',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatSelectModule,
    MatOptionModule,
    NgxMatSelectSearchModule
  ],
  templateUrl: './materials-management-filters.component.html',
  styleUrl: './materials-management-filters.component.scss'
})
export class MaterialsManagementFiltersComponent implements OnDestroy {
  constructor(
    private readonly materialGroupService: MaterialGroupService,
    private readonly materiasService: MaterialService,
    private readonly materialBrandService: MaterialBrandService,
    private snackBar: MatSnackBar
  ) { }

  @Input() form!: FormGroup;
  @Input() materialBrand: boolean = false;
  @Input() materialGroup: boolean = false;
  @Input() materialGroupWithMongoId: boolean = false;
  @Input() material: boolean = false;
  @Input() materialWithMongoId: boolean = false;
  @Input() isMultiple: boolean = false;
  @Input() loadData: boolean = undefined;
  @Output() materialGroupChange = new EventEmitter<string>();
  @Input() resetTrigger: number = 0;
  materialGroupSearch: string = '';
  materialSearch: string = '';

  materialGroupList: MaterialGroupAttributes[] = [];
  filteredMaterialGroupList: MaterialGroupAttributes[] = [];

  materialBrandList: MaterialBrandAttributes[] = []

  materialList;
  filteredMaterialList;


  getCode = getCode;
  private materialGroupSubscription: Subscription;

  ngOnInit() {
    if (this.loadData === undefined) {
      this.loadAllData();
    }
    // Escucha los cambios
    const materialGroupControl = this.form.get('materialGroupId');
    if (materialGroupControl) {
      this.materialGroupSubscription = materialGroupControl.valueChanges
        .pipe(
          distinctUntilChanged()
        )
        .subscribe((value) => {
          // Emitir al componente padre
          this.materialGroupChange.emit(value);
          if (value && (this.material || this.materialWithMongoId)) {
            this.fetchMaterials();
          }
        });
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['materialGruopList']) {
      this.filteredMaterialGroupList = [...this.materialGroupList];
    }

    if (changes['materialList']) {
      this.filteredMaterialList = [...this.materialList];
    }

    if (changes['loadData'] && changes['loadData'].currentValue === true) {
      this.loadAllData();
    }
    if (changes['resetTrigger'] && !changes['resetTrigger'].firstChange) {
      // Limpiar búsquedas
      this.materialGroupSearch = '';
      this.materialSearch = '';

      // Resetear listas filtradas
      this.filteredMaterialGroupList = [...this.materialGroupList];
      if (this.materialList) {
        this.filteredMaterialList = [...this.materialList];
      }
    }
  }

  private loadAllData(): void {
    if (this.materialGroup || this.materialGroupWithMongoId) this.fetchMaterialsGroup()
    if (this.material || this.materialWithMongoId) this.fetchMaterials();
    if (this.materialBrand) this.fetchMaterialBrands();
  }

  private fetchMaterialBrands(): void {
    this.materialBrandService.findToComboBox().subscribe((res) => {
      this.materialBrandList = res.data;
    });
  }

  fetchMaterialsGroup(): void {
    const paginationOptions = {
      search: "",
      currentPage: 1,
      limitPerPage: Number.MAX_SAFE_INTEGER,
    };

    this.materialGroupService.findToComboBox(paginationOptions).subscribe({
      next: (res) => {
        this.materialGroupList = res.data[0].data;
        // const group = this.getGroupedData(this.materialGroupList);
        this.filteredMaterialGroupList = res.data[0].data;
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error fetching materials", "Cerrar", { duration: 5000 });
      },
    });
  }

  fetchMaterials(): void {
    this.materiasService
      .findToComboBoxByGroupByCode(this.form.get("materialGroupId")?.value, this.form.get("materialBrandId")?.value)
      .subscribe((res) => {
        this.materialList = res.data;
        this.filteredMaterialList = res.data;
      });
  }

  getNestedProperty(obj: any, path: string): any {
    path = path.replace(/\[(\w+)\]/g, '.$1');
    const keys = path.split('.');
    let result = obj;
    for (const key of keys) {
      if (result == null) return undefined;
      result = result[key];
    }
    return result;
  }

  getDisplayValue(list: any[], selectedIds: any[], key: string): string {
    if (!selectedIds || selectedIds.length === 0) return '';
    return list
      .filter(item => selectedIds.includes(item._id) || selectedIds.includes(item.id) || selectedIds.includes(item.code))
      .map(item => item[key])
      .join(', ');
  }

  filterMaterialGroupList(search: string): void {
    const value = search?.toLowerCase() ?? '';
    if (value === '') {
      this.filteredMaterialGroupList = this.materialGroupList;
    } else {
      this.filteredMaterialGroupList = this.materialGroupList.filter(item =>
        item.name?.toLowerCase().includes(value) || item.externalKeys?.code?.toLowerCase().includes(value)
      );
    }
  }


  filterMaterialList(search: string): void {
    const value = search?.toLowerCase() ?? '';
    if (value === '') {
      this.filteredMaterialList = this.materialList;
    } else {
      this.filteredMaterialList = this.materialList.filter(item =>
        item.name?.toLowerCase().includes(value) || item.externalKeys?.code?.toLowerCase().includes(value)
      );
    }
  }
  ngOnDestroy(): void {
    if (this.materialGroupSubscription) {
      this.materialGroupSubscription.unsubscribe();
    }
  }
}
